import React from "react";
import Marty from "marty";

let YearInReview = React.createClass({
    componentWillMount() {
        if (Marty.isBrowser) {
            document.title = "eero - 2016 year in review";
        }
    },
    render() {
        return (
            <section className="eo-view year-in-review">
                <img src="/public/img/year-in-review/2016/EOYInfographic.png" alt="eero 2016 year in review infographic" />
            </section>
        );
    }
});

export default Marty.createContainer(YearInReview, {});



/** WEBPACK FOOTER **
 ** ./app/views/anonymous/views/yearinreview/Handler.js
 **/